import { filter } from 'rxjs/operators';
import { CryptoJsService } from './../../../services/crypto-js.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { first } from 'rxjs';
import { DepartmentDashboardService } from 'src/app/services/department-dashboard.service';
import { TokenService } from 'src/app/services/common/token.service';
import { MessageService } from 'primeng/api';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { Location } from '@angular/common'

@Component({
  selector: 'app-department-consent-form',
  templateUrl: './department-consent-form.component.html',
  styleUrls: ['./department-consent-form.component.scss'],
})
export class DepartmentConsentFormComponent implements OnInit {
  items: any[];
  selectedStatus: any;
  remarks: String;
  appId: String;
  userID: any;
  isActionSectionEnabled: boolean = false;
  userRole: any = null;
  isAppDataLoaded: boolean = false;

  constructor(
    private deptDashBoardService: DepartmentDashboardService,
    private messageService: MessageService,
    private route: ActivatedRoute,
    private router: Router,
    private tokenService: TokenService,
    private cryptoJsService: CryptoJsService,
    private activityRecordService: ActivityRecordService,
    private loader: AppLoaderService,
    private location: Location,
  ) { }

  updateDataLoadStatus(event: string) {
    if(event == 'false'){
      this.isAppDataLoaded = true;
    }else{
      this.isAppDataLoaded = false;
    }
  }
  
  ngOnInit(): void {
    const encDataD = sessionStorage.getItem('dataD') ? JSON.parse(this.cryptoJsService.DecryptSessionD(sessionStorage.getItem('dataD'))) : null;
    const loginDetails = new Map(encDataD);
    const tokenInfo = loginDetails.get('tokenInfo') ? loginDetails.get('tokenInfo') : null;
    this.userRole = tokenInfo['role'] ? tokenInfo['role'] : null;

    // this.appId = this.cryptoJsService.DecryptData(this.route.snapshot.paramMap.get('appId'));
    this.route.queryParams.subscribe(params => {
      const encryptedMobile = params['appId'];
      if (encryptedMobile) {
        this.appId = this.cryptoJsService.DecryptData(encryptedMobile);
      } else {
        setTimeout(() => this.onClickBack(), 1300);
      }
    });

    this.route.queryParams
      .subscribe(params => {
        if (params?.statusCode == this.cryptoJsService.Encrypt('C') || params?.statusCode == this.cryptoJsService.Encrypt('P')) {
          this.isActionSectionEnabled = true;
        } else {
          this.isActionSectionEnabled = false;
        }
      }
      );
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userID = JSON.parse(payload)?.sub;


    let actionId = 2; // Do not Change, it is fixed for Farmer Application Verifications
    // this.loader.start();
    this.deptDashBoardService
      .GetStatusMaster(JSON.parse(payload)?.sub, actionId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          // this.loader.close();
          this.activityRecordService.activityRecord(this.userID, 'View Application For Approval', this.appId, new Date(), 'Success');
          this.items = data.$values;
          this.selectedStatus = this.items[0];
          this.onSelectStatus();
        },
        error: (err) => {
          // this.loader.close();
          this.activityRecordService.activityRecord(this.userID, 'View Application For Approval', this.appId, new Date(), err);
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Status Master cant be Loaded',
          });
        },
      });
  }

  onClickBack() {
    this.location.back();
  }

  handleClick() {
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    let reqBody = {
      AppId: this.appId,
      Userid: JSON.parse(payload)?.sub,
      Remarks: this.remarks,
      Status: this.selectedStatus.flag
    }
    let reqBodyFinal = {
      "payload": this.cryptoJsService.EncryptPayload(JSON.stringify(reqBody))
    }
    // this.loader.start();
    this.deptDashBoardService
      .InsertFarmerApplicationApprovalRemarks(reqBodyFinal)
      .pipe(first())
      .subscribe({
        next: (data) => {
          // this.loader.close();
          let resp = JSON.stringify(data);
          this.activityRecordService.activityRecord(this.userID, 'Submit Approval', this.appId, new Date(), data);
          if (resp.startsWith('"S')) {
            this.messageService.add({
              severity: 'success',
              summary: 'Status',
              detail: resp,
            });
          }
          else {
            this.messageService.add({
              severity: 'error',
              summary: 'Status',
              detail: resp,
            });
          }

          if (data == 'S:Successfully Submitted' || data == 'S:Successfully Updated' || resp.startsWith('"S')) {
            let componentName = window.sessionStorage.getItem('currentComponent');

            if (this.userRole == 'DDMI' || this.userRole == 'DDTank') {
              let applications = JSON.parse(window.sessionStorage.getItem(componentName));
              if (applications != null) {
                applications.filter(application => {
                  return application.appID === this.appId
                }).forEach(element => {
                  element.Status_Ar = 'C',
                    element.status = this.selectedStatus.flag == 'A' ? 'Approved' : (this.selectedStatus.flag == 'RP') ? 'Return Process' : (this.selectedStatus.flag == 'R') ? 'Rejected' : 'Marked Return',
                    element.NextLevelID = 'DDMICADA',
                    element.remarks = this.remarks

                });
              }
              sessionStorage.setItem(componentName, JSON.stringify(applications));

            } else if (this.userRole == 'DD Associate') {
              // let applications = JSON.parse(window.sessionStorage.getItem("FarmerApplicationForApproval"));
              let applications = JSON.parse(window.sessionStorage.getItem(componentName));
              if (applications != null) {
                applications.filter(application => {
                  return application.appID === this.appId
                }).forEach(element => {
                  element.Status_Ar = 'C',
                    element.status = this.selectedStatus.flag == 'A' ? 'Approved' : (this.selectedStatus.flag == 'RP') ? 'Return Process' : (this.selectedStatus.flag == 'R') ? 'Rejected' : 'Marked Return',
                    element.NextLevelID = 'DDMI',
                    element.remarks = this.remarks

                });
              }

              // sessionStorage.setItem('FarmerApplicationForApproval', JSON.stringify(applications));
              sessionStorage.setItem(componentName, JSON.stringify(applications));

            } else if (this.userRole == 'DDMICADA') {

              // let applications = JSON.parse(window.sessionStorage.getItem("FarmerApplicationForApproval"));
              let applications = JSON.parse(window.sessionStorage.getItem(componentName));
              if (applications != null) {
                applications.filter(application => {
                  return application.appID === this.appId
                }).forEach(element => {

                  let nextLevelId;
                  if (this.selectedStatus.flag == 'A') {
                    nextLevelId = 'DMICADA';
                  } else if (this.selectedStatus.flag == 'RP') {
                    nextLevelId = 'Farmer'
                  } else if (this.selectedStatus.flag == 'R') {
                    nextLevelId = 'N/A'
                  }
                  element.Status_Ar = 'C',
                    element.status = this.selectedStatus.flag == 'A' ? 'Approved' : (this.selectedStatus.flag == 'RP') ? 'Return Process' : (this.selectedStatus.flag == 'R') ? 'Rejected' : 'Marked Return',
                    element.NextLevelID = nextLevelId,
                    element.remarks = this.remarks

                });
              }

              // sessionStorage.setItem('FarmerApplicationForApproval', JSON.stringify(applications));
              sessionStorage.setItem(componentName, JSON.stringify(applications));
            }
            else if (this.userRole == 'DMICADA') {

              // let applications = JSON.parse(window.sessionStorage.getItem("FarmerApplicationForApproval"));
              let applications = JSON.parse(window.sessionStorage.getItem(componentName));
              if (applications != null) {
                applications.filter(application => {
                  return application.appID === this.appId
                }).forEach(element => {

                  let nextLevelId;
                  if (this.selectedStatus.flag == 'A') {
                    nextLevelId = 'Vendor';
                  } else if (this.selectedStatus.flag == 'RP') {
                    nextLevelId = 'Farmer'
                  } else if (this.selectedStatus.flag == 'R') {
                    nextLevelId = 'N/A'
                  }

                  element.Status_Ar = 'C',
                    element.status = this.selectedStatus.flag == 'A' ? 'Approved' : (this.selectedStatus.flag == 'RP') ? 'Return Process' : (this.selectedStatus.flag == 'R') ? 'Rejected' : 'Marked Return',
                    element.NextLevelID = nextLevelId,
                    element.remarks = this.remarks

                });
              }

              // sessionStorage.setItem('FarmerApplicationForApproval', JSON.stringify(applications));
              sessionStorage.setItem(componentName, JSON.stringify(applications));
            }
            else if (this.userRole == 'JE-EW' || this.userRole == 'DD-EW') {
              let applications = JSON.parse(window.sessionStorage.getItem(componentName));
              if (applications != null) {
                applications.filter(application => {
                  return application.appID === this.appId
                }).forEach(element => {

                  // let nextLevelId;
                  // if(this.selectedStatus.flag == 'A'){
                  //   nextLevelId = 'DMICADA';
                  // }else if(this.selectedStatus.flag == 'RP'){
                  //   nextLevelId = 'Farmer'
                  // }else if(this.selectedStatus.flag == 'R'){
                  //   nextLevelId = 'N/A'
                  // }

                  element.Status_Ar = 'C',
                    element.status = this.selectedStatus.flag == 'A' ? 'Approved' : (this.selectedStatus.flag == 'RP') ? 'Return Process' : (this.selectedStatus.flag == 'R') ? 'Rejected' : 'Marked Return',
                    // element.NextLevelID = nextLevelId,
                    element.remarks = this.remarks

                });
              }

              sessionStorage.setItem(componentName, JSON.stringify(applications));

            }
            this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Farmer Application Processed Successfully.' });

            setTimeout(() => {
              const encDataD = sessionStorage.getItem('dataD') ? JSON.parse(this.cryptoJsService.DecryptSessionD(sessionStorage.getItem('dataD'))) : null;
              const loginDetails = new Map(encDataD);
              const isJEEWLogin = loginDetails.get('isJEEW') ? loginDetails.get('isJEEW') : null;
              const isDDEWLogin = loginDetails.get('isDDEW') ? loginDetails.get('isDDEW') : null;

              if (componentName == 'FarmerApplicationForApprovalPending') {
                // this.router.navigate(['/department/farmer-applications/pending']);
                if (isJEEWLogin === '1') {
                  this.router.navigate(['/ew-je/farmer-applications/pending']);

                } else if (isDDEWLogin === '1') {
                  this.router.navigate(['ew-department/farmer-applications/pending']);
                } else {
                  this.router.navigate(['/department/farmer-applications/pending']);
                }
                // window.close();
              }
              else if (componentName == 'FarmerApplicationForApprovalCurrent') {
                // this.router.navigate(['/department/farmer-applications/current']);
                if (isJEEWLogin === '1') {
                  this.router.navigate(['/ew-je/farmer-applications/current']);
                } else if (isDDEWLogin === '1') {
                  this.router.navigate(['ew-department/farmer-applications/current']);
                } else {
                  this.router.navigate(['/department/farmer-applications/current']);
                }
                // window.close();
              }
            }, 1000)
          }
          // this.router.navigate(['department']);
        },
        error: (err) => {
          // this.loader.close();
          this.activityRecordService.activityRecord(this.userID, 'Submit Approval', '', new Date(), err);
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
    // this.router.navigate(['/department/farmer-applications']);
  }

  onSelectStatus() {
    if (this.selectedStatus.flag == 'A') {
      if (this.userID.startsWith('D.A')) {
        this.remarks = 'Checked and Verified';
      } else if (this.userID.startsWith('DDMI') || this.userID.startsWith('DDTank')) {
        this.remarks = 'Recommended';
      } else if (this.userID.startsWith('DMICADA')) {
        this.remarks = 'Approved';
      }
    } else {
      this.remarks = null;
    }
  }

}